<div class="loader" [ngClass]="'loader--' + size" [class.sticky]="overlay">
  <span></span>
</div>
